const StoreAutoDiscounts = `
    discount.dlvry,                     disc_delivery,                  false;
    discount.free_delivery,             disc_free_delivery,             false;
    discount.new_user_discount,         disc_new_user,                  false;
    discount.pickup,                    disc_pickup,                    false;
    discount.exclude_giftcards,         disc_gift_cards,                false;
    discount.instore,                   disc_instore,                   false;
`
export default StoreAutoDiscounts;